import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import "./ModalAutorizacion";
import { validarPasswordEliminar } from '../../../../Services/Validaciones';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { estiloColorError, estilosModal, estiloFiltroEncabezados } from '../../../../Services/PaletaDeColores';
import { deleteRequisicionDocumento } from '../../../../Services/Api';


export default class ModalAutorizacion extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      titulo: props.titulomodal,
      item: props.item,

      colormsgerror: estiloColorError().msgerror,
      estilosmodal: estilosModal(),
      colortitulo: estiloFiltroEncabezados().colortitulos,

      txtpassword: "",
      vermsgerrortxtpassword: false,
      msgerrortxtpassword: "",

    }

  }
  async componentDidMount() {
    setTimeout(async () => {
      this.refInput.focus();
    }, 500);
  }

  setLoadingSpinner = (bandera) => {
    this.props.setloadingspinner(bandera);
  }

  showModal = (accion) => {
    this.setState({ show: false });
    setTimeout(() => {
      this.props.cerrarModalAtutorizacion(accion);
    }, 200);
  }

  escribir = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  eliminarItem = async () => {

    let validacionescorrectas = true
    this.setState({ vermsgerrortxtpassword: false })

    let txtpassword = validarPasswordEliminar(this.state.txtpassword.trim())
    if (txtpassword.codigo == "invalid") {
      this.setState({ msgerrortxtpassword: txtpassword.mensaje })
      this.setState({ vermsgerrortxtpassword: true })
      validacionescorrectas = false;
    }

    if (validacionescorrectas) {
      this.setLoadingSpinner(true);
      var resp = {};
      var json = {};

      if (this.props.accion == 'doc_requisicion') {
        json = {
          idcatalogo_requisicion_documentos: this.state.item.idcatalogo_requisiciones_documentos,
          password: this.state.txtpassword
        }
        resp = await deleteRequisicionDocumento(json)
      }


      if (resp.code == 1000) {
        toast.error("Error de conexión", { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
        this.setLoadingSpinner(false)
        return;
      }
      else if (resp.code == 200 || resp.code == 300) {
        this.setLoadingSpinner(false)
        toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        return;
      }
      else {
        this.showModal('1')
      }
    }
  }


  render() {
    return (

      <>
        <ToastContainer />

        <Modal isOpen={this.state.show}
          size="md"
          aria-labelledby=""
          centered>
          <ModalBody>
            <div className="divTituloModal">
              <label className="modalLblTitulo letraTitulos" style={{ color: this.state.colortitulo }} >{this.state.titulo}</label>
            </div>

            <br />

            <div className="divModalEliminar">
              <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal, boxSizing: "content-box" }}>

                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Ingresa tu contraseña</p>

                <input className='lblTextoModal letraNormal' style={{ color: this.state.estilosmodal.colorlbltextomodal, backgroundColor: this.state.estilosmodal.fondocontenedormodal, border: 'none', borderBottom: this.state.estilosmodal.colorborderbottom }}
                  type={'password'} value={this.state.txtpassword} onChange={this.escribir("txtpassword")} ref={(input) => { this.refInput = input; }}></input>

                {this.state.vermsgerrortxtpassword ? <p className="msgError letraNormal"
                  style={{ color: this.state.colormsgerror }}>{this.state.msgerrortxtpassword}</p> : null}

              </div>
            </div>

            <div className="divBtnContenedorModal" >
              <Button className="btnCancelModal" onClick={() => this.showModal('0')}>Cancelar</Button>
              <Button className="btnAceptarModal" onClick={() => this.eliminarItem()} >Continuar</Button>
            </div>

          </ModalBody>

        </Modal>
      </>
    )
  }
}
